import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

import MvpItem from './MvpItem';
import { CloseButton } from '@repo/common';

const MyMvpsModal = ({ data, onClose, $isMobile }) => {
  useEffect(() => {
    const originalStyle = window.getComputedStyle(document.body).overflow;
    const originalPadding = window.getComputedStyle(document.body).paddingRight;

    const scrollBarWidth =
      window.innerWidth - document.documentElement.clientWidth;

    if (scrollBarWidth > 0) {
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = `${scrollBarWidth}px`;
    } else {
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.body.style.overflow = originalStyle;
      document.body.style.paddingRight = originalPadding;
    };
  }, []);

  return ReactDOM.createPortal(
    <div
      className={`fixed inset-0 z-[10000000] flex bg-surface-black40 ${
        $isMobile ? '' : 'items-center justify-center'
      }`}
    >
      <div className='absolute inset-0' onClick={onClose} />

      <div
        className={`relative flex flex-col bg-grayscale-gray01 overflow-hidden ${
          $isMobile
            ? 'w-full h-full max-w-none max-h-none rounded-none'
            : 'w-full max-w-[700px] h-full max-h-[700px] rounded-[30px]'
        }`}
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className='w-full flex flex-row-reverse tabletH:flex-row items-center justify-between px-4 py-3 tabletH:pt-6 tabletH:pb-[18px] tabletH:px-[30px] bg-grayscale-gray01 border-b-grayscale-gray02 border-b'>
          <div className='w-6 h-6' />
          <div className='mx-auto typo-b16Strong text-text-primary'>
            My MVPs
          </div>

          <CloseButton type='default' onClick={onClose} />
        </div>

        <div className='flex-1 overflow-y-auto p-4 tabletH:p-6 w-full'>
          <div
            className={`grid gap-2 justify-center items-start justify-items-center ${
              $isMobile ? 'grid-cols-3' : 'grid-cols-4'
            }`}
          >
            {data.map((item, index) => (
              <MvpItem key={index} item={item} noClamp />
            ))}
          </div>
        </div>

        <div
          className='w-full h-[72px] px-[30px] py-6 flex justify-center items-start gap-2 border-t border-t-grayscale-gray02 bg-grayscale-gray01
              typo-b16Strong text-grayscale-gray09'
        >
          You've earned{' '}
          <span className='text-green-deep03'>{data.length} MVP</span> stamps!
          👏
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default MyMvpsModal;
